import { render, staticRenderFns } from "./TheTextView.vue?vue&type=template&id=5488ed23&"
import script from "./TheTextView.vue?vue&type=script&lang=js&"
export * from "./TheTextView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports